import { Component, Input, OnDestroy, OnInit, SimpleChanges, OnChanges } from '@angular/core';
import { ReactionEvent } from './ReactionCfg';

import { Observable, Subscription } from 'rxjs';

interface AnimationState {
	char: string;
	time: number;
	left: number;
	delay1: number;
	delay2: number;
	reverseSpin: boolean;
}

const animationTime = 20000;
const maxVisible = 10;
const spinTime = 10000;

@Component({
	selector: 'reactions-player',
	template: `
	@for(emoji of emojis; track emoji) {
		<div class="floatWrap"
			[style.left.%]="emoji.left"
			[style.animationDelay.ms]="emoji.delay1">
			<div class="spinContainer"
				[class.reverseSpin]="emoji.reverseSpin"
				[style.animationDelay.ms]="emoji.delay2"
			>
				<div class="spinArm">
					<div class="spinCenter"
						[style.animationDelay.ms]="emoji.delay2">
						<span class="emoji">{{emoji.char}}</span>
					</div>
				</div>
			</div>
		</div>
	}
	`,
	standalone: false,
	styleUrls: ['./ReactionsPlayer.Component.ng.less']
})
export class ReactionsPlayerComponent implements OnInit, OnDestroy, OnChanges {
	@Input() public reactions$: Observable<ReactionEvent>;
	@Input() public isHidden: boolean;

	public emojis: AnimationState[] = [];
	public sub: Subscription;

	public ngOnInit(): void {
		this.sub = this.reactions$.subscribe(e => {
			if(this.isHidden ||
				maxVisible < this.emojis.reduce((sum, emoji) => sum + (emoji.char === e.char ? 1 : 0), 0)) {
				return;
			}

			for(let i=0; i<e.count; i++) {
				this.addEmoji(e.char);
			}
			this.scheduleCleanup();
		});
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if(changes.isHidden) {
			window.clearTimeout(this.timer);
			this.timer = null;
			this.runCleanup();
		}
	}

	public ngOnDestroy(): void {
		this.sub?.unsubscribe();
	}

	private addEmoji(char: string): void {
		this.emojis.push({
			char,
			time: Date.now(),
			left: Math.random() * 100,
			delay1: -Math.floor(Math.random() * 1000),
			delay2: -Math.floor(Math.random() * spinTime),
			reverseSpin: Math.random() > 0.5
		});
	}

	private timer: number;
	private scheduleCleanup(): void {
		if(this.timer) {
			return;
		}
		this.timer = window.setTimeout(() => {
			this.timer = undefined;
			this.runCleanup();
		}, animationTime);
	}

	private runCleanup(): void {
		if(this.isHidden) {
			this.emojis = [];
			return;
		}

		const cutoffTime = Date.now() - animationTime;
		this.emojis = this.emojis.filter(e => e.time > cutoffTime);
		if(this.emojis.length) {
			this.scheduleCleanup();
		}
	}

}
